import { derived, writable } from "svelte/store";
import {
  socialLinkColor,
  socialLinkIcon,
} from "../../../../elements/ProfileContactSideBarShared/SocialLinks/utils";
import {
  candidateStore,
  contactRecordsStore,
  profileRecordsStore,
  todosModalItemStore,
} from "../../stores";

const matchedSocialLinksStore = derived(
  [todosModalItemStore, candidateStore],
  ([$todosModalItemStore, $candidateStore]) => {
    if (
      !$todosModalItemStore?.candidateId ||
      $todosModalItemStore?.candidateId !== $candidateStore?.candidateId
    )
      return {};

    const { socialLinks = [] } = $candidateStore || {};
    return Object.fromEntries(
      socialLinks.map((link) => [
        link,
        {
          icon: socialLinkIcon(link),
          color: socialLinkColor(link),
          type: "social",
        },
      ]),
    );
  },
);

const matchedContactRecordStore = derived(
  [contactRecordsStore],
  ([$contactRecordsStore]) => {
    const matchedData = $contactRecordsStore || [];
    const ret = {};
    Object.values(matchedData).forEach((x) => {
      x.atsRecords.forEach((r) => {
        if (!r.nameMatchOnly) ret[r.key] = { ...r, type: "crm" };
      });
    });

    return ret;
  },
);

const matchedProfileRecordStore = derived(
  [todosModalItemStore, profileRecordsStore],
  ([$todosModalItemStore, $profileRecordsStore]) => {
    const data = $profileRecordsStore || {};
    const matchedData = data[$todosModalItemStore?.candidateId] || {};
    const { crmRecords = {} } = matchedData;
    return Object.fromEntries(
      Object.entries(crmRecords)
        .filter(([, record]) => !record.nameMatchOnly)
        .map(([key, record]) => [key, { ...record, type: "crm" }]),
    );
  },
);

const matchedLinksStore = derived(
  [
    matchedSocialLinksStore,
    matchedContactRecordStore,
    matchedProfileRecordStore,
  ],
  ([
    $matchedSocialLinksStore,
    $matchedContactRecordStore,
    $matchedProfileRecordStore,
  ]) => ({
    ...$matchedSocialLinksStore,
    ...$matchedContactRecordStore,
    ...$matchedProfileRecordStore,
  }),
);

export const linksVisibleWidth = writable(0);

export const matchedLinksWithVisibilityStore = derived(
  [linksVisibleWidth, matchedLinksStore],
  ([$linksVisibleWidth, $matchedLinksStore]) => {
    // Each icon takes up 20px plus 8px gap = 28px
    const maxIcons = Math.floor($linksVisibleWidth / 28);

    // If there are more than maxIcons icons, show one less and add a "more" icon
    const maxIconsModified =
      Object.keys($matchedLinksStore).length > maxIcons
        ? maxIcons - 1
        : maxIcons;

    return Object.fromEntries(
      Object.entries($matchedLinksStore).map(([key, value], iconCounter) => [
        key,
        { ...value, show: !(iconCounter > maxIconsModified) },
      ]),
    );
  },
);
